import requiredFieldConfig from '../data/requiredFieldConfig';
import { collectConditionFields, evaluateCompositeCondition, isEmptyField } from './conditionUtils';

/*
 * When loan forms become read-only.
 *
 * Locked once the loan is submitted (TPO.X90 Initial TPO Submittal Date set),
 * or - before submittal - once disclosures are out:
 *   (CX.ALL.DISCLOSURES.SENT = Y and TPO.X90 empty) or
 *   (TPO.X92 Ready to Disclose Date set and TPO.X90 empty)
 *
 * The disclosure half is the ShowIf of the "Disclosures Sent" group on the
 * Product Pricing & Lock page in requiredFields.json, so the pricing block and
 * the form lock always use the same rule.
 */
const disclosuresSentCondition = requiredFieldConfig.Pages
    .find(p => p.Page === 'Product Pricing & Lock')
    ?.FieldGroups.find(g => g.Group === 'Disclosures Sent')
    ?.ShowIf;

// Field ids a page must read to evaluate isLoanEditLocked().
export const LOAN_EDIT_LOCK_FIELD_IDS = [
    ...new Set(['TPO.X90', ...collectConditionFields(disclosuresSentCondition)])
];

export const isLoanSubmitted = (values = {}) => !isEmptyField(values['TPO.X90']);

export const isLoanEditLocked = (values = {}) =>
    isLoanSubmitted(values) || evaluateCompositeCondition(disclosuresSentCondition, values);
